import { render, staticRenderFns } from "./CommunicationItemRecords.vue?vue&type=template&id=2ae5b4cc&scoped=true&"
import script from "./CommunicationItemRecords.vue?vue&type=script&lang=js&"
export * from "./CommunicationItemRecords.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationItemRecords.vue?vue&type=style&index=0&id=2ae5b4cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae5b4cc",
  null
  
)

export default component.exports